/* TrustedCertificateComponent */
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging -- disabled to allow to inherit from AbstractComponent */
import { Component, Element, Prop, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import TrustedCertificateTemplate from './cwc-trusted-certificate.template';
import { AbstractComponent } from '@cewe-designsystem/abstract';

@Component({
  tag: 'cwc-trusted-certificate',
  styleUrl: './cwc-trusted-certificate.scss',
  shadow: false,
})
export class TrustedCertificateComponent {
  /**
   * element
   */
  @Element() element: HTMLElement;

  /**
   * trustedShopId
   */
  @Prop() trustedShopId: string;

  /**
   * trustedShopUrl
   */
  @Prop() trustedShopUrl: string;

  /**
   * trustedShopConfig
   */
  @Prop() trustedShopConfig: string;

  /**
   * concatenated url to trusted-shop script
   */
  scriptUrl: string;

  /**
   * Called every time the component is connected to the DOM.
   * When the component is first connected, this method is called before componentWillLoad.
   * It is important to note that this method can be called more than once, everytime, the element is attached or moved in the DOM.
   * This lifecycle hook follows the same semantics as the one described by the Custom Elements Spec
   */
  connectedCallback() {
    this.scriptUrl = this.trustedShopUrl + this.trustedShopId + '.js';
  }

  /**
   * Called every time the component is disconnected from the DOM, i.e., it calls be dispatched more than once
   * DO not confuse with a "onDestroy" kind of event.
   * This lifecycle hook follows the same semantics as the one described by the Custom Elements Spec.
   */
  disconnectedCallback() {}

  /**
   * Called once just after the component is first connected to the DOM.
   * A promise can be returned, that can be used to wait for the first render.
   */
  componentWillLoad() {}

  /**
   * Called once just after the component fully loaded and the first render() occurs.
   */
  componentDidLoad() {}

  /**
   * Called before every render().
   * A promise can be returned, that can be used to wait for the upcoming render.
   */
  componentWillRender() {}

  /**
   * Called after every render().
   */
  componentDidRender() {}

  /**
   * Called when the component is about to be updated because some Prop() or State() changed.
   * It is never called during the first render().
   * A promise can be returned, that can be used to wait for the next render.
   */
  componentWillUpdate() {}

  /**
   * Called just after the component updates. It is never called during the first render().
   */
  componentDidUpdate() {}

  /**
   * Renders the certificate and ensure a scoped _tsConfig var to prevent side effects
   * to possible variable collisions, _tsConfig has to be global, thanks to trustedshops.de
   * @private
   */
  _renderTrustedCertificate() {
    (() => {
      const config = JSON.parse(this.trustedShopConfig),
        _ts = document.createElement('script');

      // set customElementId to internal render container in template
      config['customElementId'] = 'cwc-trusted-certificate-render';
      /*config['responsive'] = {
        'variant': config.variant,
        'customElementId': config['customElementId']
      };*/

      this.trustedShopConfig = JSON.stringify(config);

      _ts.type = 'text/javascript';
      _ts.charset = 'utf-8';
      _ts.async = true;
      _ts.src = this.scriptUrl;

      this.element.appendChild(_ts);
    })();
  }

  /**
   * render
   */
  render() {
    this._renderTrustedCertificate();

    return <TrustedCertificateTemplate controller={this} />;
  }
}

/**
 * mixin abstract functions
 */
Object.setPrototypeOf(TrustedCertificateComponent.prototype, AbstractComponent.prototype);

export interface TrustedCertificateComponent extends AbstractComponent {}
